import { CtaButton, Spinner } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledNarrowerContainer = styled.div`
  margin: 0 auto;
  margin-top: ${rem('40px')};
  padding: 0 10%;

  & > *:last-child {
    margin-bottom: 0;
    margin-top: ${rem('32px')};
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    width: 100%;
  }
`;
export const StyledContinueButton = styled(CtaButton).attrs({
  tag: 'button',
  user: 'tenant',
})`
  text-transform: uppercase;
  margin: 0;

  span {
    position: relative;
  }

  &:hover {
    color: ${({ theme, variant }) =>
      variant === 'secondary' && theme.colors.tenant.mainAlternate};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    max-width: ${rem('264px')};
    width: 100%;
  }
`;

export const StyledSpinner = styled(Spinner)`
  position: absolute;
  right: -${rem('8px')};
  top: 28%;
`;
//common styles to be shared over all components of the page
export const StyledH2 = styled.h2`
  font-size: ${rem('24px')};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.cross.black};
  margin-top: 0;
  line-height: 1.3;
`;
//common styles to be shared over all components of the page
export const StyledH3 = styled.h3`
  font-size: ${rem('20px')};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.cross.black};
  margin-top: 0;
  line-height: 1.3;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; // Aligns children (button) to the right
`;

export const RowContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  gap: ${rem('10px')};
  align-items: center;
`;

export const StyledFieldWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem('30px')};
`;
